// extracted by mini-css-extract-plugin
module.exports = {"c-button":"connectionDialout_c-button__XvEe6","c-spacer":"connectionDialout_c-spacer__2qu6c"};